import { Empty, Space } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import RentalRedirection from 'app/components/Core/Rental/RedirectionButton'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

type Props = {
  status: ILineItemStatus
}

const MissingInformationEmpty: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { status }
}) => {
  const { tComponent } = ToolBox.useString()
  const translate = (id: string) =>
    tComponent({
      componentType: 'core',
      componentName: 'empty',
      recordType: RecordType.line_item,
      id: `missing_information.${id}`
    })

  return (
    <Empty
      description={
        <Space direction="vertical">
          <Choose>
            <When condition={status === 'canceled'}>
              <p>{translate('canceled_error')}</p>
            </When>
            <Otherwise>
              <p>{translate('no_data_description')}</p>
            </Otherwise>
          </Choose>
          <RentalRedirection rentalId={member.id} />
        </Space>
      }
    />
  )
}

export default MissingInformationEmpty
